import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { schedularTherapistFilterAction } from 'src/redux/actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

function* editSplitTaskMin(action: any): SagaReturnType<any> {
  try {

    yield put({type:schedularTherapistFilterAction.EDIT_SPLIT_TASK_MIN_LOADING})
    const response = yield call(
      therapistSchedulingServices.editSplitTaskMin,
      action.payload
    );
    if (response?.status === 200) {
      yield put({
        type: schedularTherapistFilterAction.EDIT_SPLIT_TASK_MIN_SUCCESS,
        payload: response.data,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({
      type: schedularTherapistFilterAction.EDIT_SPLIT_TASK_MIN_FAILURE,
      payload: error,
    });
  }
}

function* editSplitTaskMinSaga() {
  yield takeEvery(
    schedularTherapistFilterAction.EDIT_SPLIT_TASK_MIN_REQUEST,
    editSplitTaskMin
  );
}

export default editSplitTaskMinSaga;
